var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.548,
    height: 21,
    viewBox: "0 0 20.548 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_14269",
    "data-name": "Path 14269",
    d: "M9.746,11.779h0l-.813-1.163L2.466,1.365H5.25L10.47,8.83l.813,1.163,6.784,9.7H15.282ZM18.066,0,11.424,7.721,6.119,0H0L8.022,11.675,0,21H1.813l7.014-8.153L14.43,21h6.119L12.229,8.892h0L19.879,0Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.06e8b490.svg";
export { ForwardRef as ReactComponent };